var React = require('react');

function LogoFull (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0,0H6.92V12.13H17.26V0h6.92V30H17.26V18.09H6.92V30H0Z","key":0}),React.createElement("path",{"d":"M54.07,0,39.25,30H31.56L37.1,18.69,26.52,0h8l6.36,11.83L46.43,0Z","key":1}),React.createElement("path",{"d":"M79.56,10.84A10.42,10.42,0,0,1,68.83,21.67H63V30H56.11V0H68.83C75.09,0,79.56,4.54,79.56,10.84Zm-7,0c0-3-2-5.19-4.77-5.19H63V16h4.73C70.55,16,72.56,13.84,72.56,10.84Z","key":2}),React.createElement("path",{"d":"M82.81,0H101.1V5.58H89.74v6.81H101.1v5.44H89.74v6.61H101.1V30H82.81Z","key":3}),React.createElement("path",{"d":"M124.4,20.49,129.66,30H121.8l-4.71-8.32h-3.63V30h-6.92V0h12.72A10.4,10.4,0,0,1,130,10.84,10.4,10.4,0,0,1,124.4,20.49ZM113.47,16h4.74C121,16,123,13.84,123,10.85s-2-5.19-4.78-5.19h-4.74Z","key":4})]);
}

LogoFull.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 129.98 30"};

module.exports = LogoFull;

LogoFull.default = LogoFull;
